module.exports = __webpack_public_path__ + "static/img/orders.d99a917.svg";